import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "root-map-wrapper" };
const _hoisted_2 = {
    id: "map",
    ref: "map",
    "data-cy": "map"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createCommentVNode(" 네이버 지도 ")
        ], 512 /* NEED_PATCH */)
    ]));
}
